import "../../pages/new/new.scss"

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../../api/axios';
import { getAllThesis } from '../../services/thesisService';
import { getThesisStatusById } from '../../services/thesisAssignedService';
import { getExaminers } from '../../services/instructorService';
import TextBox from './TextBox';
import { jwtDecode } from "jwt-decode";
export const AddExaminerFeedback = () => {

    const { thesisStatusId } = useParams();
    const [feedback, setFeedback] = useState({
        thesisId: '',
        title: '',
        abstract: '',
        studentId: '',
        studentName: '',
        enrollmentNumber: '',
        mentorName: '',
        examinerName: '',
        overallFeedback: '',
        presentationFeedback: '',
        reportFeedback: '',
        otherFeedback: '',
        type: '',
        problemStmt: '',
        literatureSurvey: '',
        methodology: '',
        results: '',
        conclusionFuturework: '',
        presentation: '',
        gradeProposedProblem: null,
        gradeProposedSolution: null,
        gradeProblemUnderstanding: null,
        gradeAcademicRigour: null,
        gradeWorkQuantum: null,
        gradeOverall: null,
        month: '',
        year: '',
        problemSolved: '',
        gradeConclusionFuturework: null,
        gradeResults: null,
        gradeMethodology: null,
        gradeLiteratureSurvey: null,
        reportMarks: '',
        presentationMarks: '',
        vivaMarks: '',
    });

    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [examinerFeedbacks, setExaminerFeedbacks] = useState([]);

    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    const userRole = decoded.roles;
    const statusLabelMap = {
    WORK_IN_PROGRESS: "End Term",
    REPORT_REVISION_REQUIRED: "Revised Report",
    RESUBMISSION: "End Term Resubmission"
};

    const fetchStatus = async (id) => {
        try {
            const response = await getThesisStatusById(id);
            setFeedback(feedback => ({
                ...feedback,
                thesisStatusId: id,
                type: response.data.report_type,
                term_type: response.data.term_type,
                termThesisStatus: response.data.termThesisStatus,
                attemptNumber: response.data.attempt_number,
                thesisId: response.data.thesis_id,
                studentName: response.data.student_name,
                title: response.data.thesis_title,
                mentorName: response.data.mentor_name,
                enrollmentNumber: response.data.enrollment_number,
                studentId: response.data.student_id,
                abstract: response.data.thesis_abstract,
                folderLink: response.data.folder_link,
                reportLink: response.data.report_link,
                presentationLink: response.data.presentation_link,
                presentationVideoLink: response.data.presentation_video_link,
                turnitin: response.data.turnitin,
                rebuttalReportLink: response.data.rebuttal_report_link,
                dateSubmitted: response.data.date_submitted,
                reportMonth: response.data.report_month
            }));

           // console.log(response.data);
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };

    useEffect(() => {
        
        fetchStatus(thesisStatusId);
    }, [thesisStatusId]);


    const goBack = (e) => {
        navigate('/examiner');
    };

    const fetchExaminerFeedbacks1 = async (studentId) => {
        try {
            const response = await axiosInstance.get(
            `/thesisFeedbacks?id=${studentId}&isView=false`
            );
            setExaminerFeedbacks(response.data.data); 
         //   console.log(response.data.data);
        } catch (error) {
            console.error("Error fetching examiner feedbacks:", error);
        }
        };

        const fetchExaminerFeedbacks = async (studentId) => {
        try {
            const response = await axiosInstance.get(
            `/thesisFeedbacks?id=${studentId}&isView=false`
            );
            const data = response.data.data;
           // console.log("Fetched Examiner Feedbacks:", data);
            const filtered = data.filter( (exam) => exam.is_examiner && exam.thesis_status_id !== Number(feedback.thesisStatusId) && exam.date_submitted < feedback.dateSubmitted );           
            //((feedback.type === 'Phase3' && (exam.report_type === 'Phase3' || exam.report_type === 'Phase2' ||exam.report_type === 'Phase1' || exam.report_type === 'ResearchProposal'))
         //   || (feedback.type === 'Phase2' && (exam.report_type === 'Phase2' || exam.report_type === 'Phase1' || exam.report_type === 'ResearchProposal')) 
         //   || (feedback.type === 'Phase1' && (exam.report_type === 'Phase1' || exam.report_type === 'ResearchProposal')) 
         //   || (exam.report_type === 'ResearchProposal' && feedback.type === 'ResearchProposal')));
         //   console.log("Data:", data);
          //  console.log("Filtered:", filtered);
          //  console.log(feedback.thesisStatusId, feedback.type );
            const grouped = filtered.reduce((acc, item) => {
            const key = item.report_type + "_" + item.term_type;

            if (!acc[key]) {
                acc[key] = {
                    report_type: item.report_type,
                    term_type: item.term_type,
                    thesis_viva_status: item.thesisVivaStatus,
                    report_link: item.report_link,
                    feedbacks: []
                };
            }

            acc[key].feedbacks.push(item);
            return acc;
        }, {});
       //  console.log("Grouped Object:", filtered);
        // convert to array
        setExaminerFeedbacks(Object.values(grouped));
      
      //  console.log("Grouped:", Object.values(grouped));
         //   setExaminerFeedbacks(filtered); 
      //     console.log(filtered);
        //   console.log(feedback.thesisStatusId)
        } catch (error) {
            console.error("Error fetching examiner feedbacks:", error);
        }
        }; 


    useEffect(() => {
        if (feedback.studentId) {
            fetchExaminerFeedbacks(feedback.studentId);
        }
        }, [feedback.studentId]);

    const validateForm = () => {
        const errors = {};
        if (!feedback.thesisId) {
            errors.title = 'thesis is required';
        }
        if (!feedback.type) {
            errors.type = 'type is required';
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFeedback({ ...feedback, [name]: value || '' });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
       // console.log("inside submit");
        var response = '';
        try {

          //  console.log(feedback);
            var addFeedback = {
                studentId: feedback.studentId,
                thesisStatusId: thesisStatusId,
                examinerId: parseInt(localStorage.getItem('examinerId'), 10),
                month: feedback.month,
                year: feedback.year,
                overallFeedback: feedback.overallFeedback,
                reportFeedback: feedback.reportFeedback,
                presentationFeedback: feedback.presentationFeedback,
                otherFeedback: feedback.otherFeedback,
                type: feedback.type,
                problemStmt: feedback.problemStmt,
                literatureSurvey: feedback.literatureSurvey,
                methodology: feedback.methodology,
                results: feedback.results,
                conclusionFuturework: feedback.conclusionFuturework,
                presentation: feedback.presentation,

                gradeProposedProblem: feedback.gradeProposedProblem,
                gradeProposedSolution: feedback.gradeProposedSolution,
                gradeProblemUnderstanding: feedback.gradeProblemUnderstanding,
                gradeAcademicRigour: feedback.gradeAcademicRigour,
                gradeWorkQuantum: feedback.gradeWorkQuantum,
                gradeOverall: feedback.gradeOverall || null,
                problemSolved: feedback.problemSolved,

                gradeConclusionFuturework: feedback.gradeConclusionFuturework,
                gradeResults: feedback.gradeResults,
                gradeMethodology: feedback.gradeMethodology,
                gradeLiteratureSurvey: feedback.gradeLiteratureSurvey,
                presentationMarks: feedback.presentationMarks,
                vivaMarks: feedback.vivaMarks,
                reportMarks: feedback.reportMarks

            }
            response = await axiosInstance.post('/feedbacks', addFeedback, { showToastOnResponse: true });


          //  console.log(response);


        } catch (error) {
            console.log('Error saving feedback. Please try again later.');
            console.log(error);
        }

        try {

           // console.log(feedback);
        

            response = await axiosInstance.put(`/updateThesisFeedbackStatus?thesisStatusId=${thesisStatusId}&examinerId=${parseInt(localStorage.getItem('examinerId'), 10)}`, { showToastOnResponse: true });


          //  console.log(response);
            navigate('/examiner');

        } catch (error) {
            console.log('Error saving feedback. Please try again later.');
            console.log(error);
        }
    };

    return (
        <div>
            <div className="top">
                <h1>{'Add Feedback'}</h1>
            </div>
            <div className="bottom">
                <div className="left"></div>
                <div className="right">
                    <form onSubmit={handleSubmit}>
                        <div className="formInput">
                            <label>Student Enrollment Number</label>
                            <input type="text"
                                name="enrollmentNumber"
                                value={feedback.enrollmentNumber}
                                readOnly={true}
                                onChange={handleChange}
                                className={errors.enrollmentNumber ? 'error' : ''} />
                            {errors.enrollmentNumber && <div className="error-text">{errors.enrollmentNumber}</div>}
                        </div>

                        <div className="formInput">
                            <label>Student Name</label>
                            <input type="text"
                                name="studentName"
                                value={feedback.studentName}
                                readOnly={true}
                                onChange={handleChange}
                                className={errors.studentName ? 'error' : ''} />
                            {errors.studentName && <div className="error-text">{errors.studentName}</div>}
                        </div>

                        
                        <div className="formInput">
                            <label>Thesis Title</label>
                            <TextBox type="text"
                                readOnly={true}
                                value={feedback.title}
                                name="title"
                                onChange={handleChange}
                                className={errors.title ? 'error' : ''} />
                            {errors.title && <div className="error-text">{errors.title}</div>}
                        </div>


                 {/*       <div className="formInput">
                            <label>Report type</label>
                            <input type="text"
                                name="type"
                                value={feedback.type}
                                readOnly={true}
                                onChange={handleChange}
                                className={errors.type ? 'error' : ''} />
                            {errors.type && <div className="error-text">{errors.type}</div>}
                        </div>
                        <div className="formInput">
                            <label>Submission Type</label>
                            <input type="text"
                                name="type"
                                value={feedback.termThesisStatus ? statusLabelMap[feedback.termThesisStatus] || feedback.termThesisStatus : ''}
                                readOnly={true}
                                onChange={handleChange}
                                className={errors.type ? 'error' : ''} />
                            {errors.type && <div className="error-text">{errors.type}</div>}
                            
                        </div>
*/}
                       {/* <div className="formInput">
                            <label>Submission Count</label>
                            <input type="text"
                                name="type"
                                value={feedback.attemptNumber}
                                readOnly={true}
                                onChange={handleChange}
                                className={errors.type ? 'error' : ''} />
                            {errors.type && <div className="error-text">{errors.type}</div>}
                               
                        </div> */}

                        {feedback.type == "Monthly" &&
                            <div className="formInput">
                                <label>Report Month</label>
                                <input type="text"
                                    name="reportMonth"
                                    value={feedback.reportMonth}
                                    readOnly
                                    className={errors.reportMonth ? 'error' : ''} />
                                {errors.reportMonth && <div className="error-text">{errors.reportMonth}</div>}
                            </div>
                        }

                        <div className="Monthly">
                            <div className="monthlyInput">
                                <label>Thesis Abstract</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="abstract"
                                    value={feedback.abstract}
                                    readOnly={true}
                                    onChange={handleChange}
                                    className={errors.abstract ? 'error' : ''} />
                                {errors.abstract && <div className="error-text">{errors.abstract}</div>}
                            </div>
                        </div>
                        

{/* <div className="formInput">
                            <label htmlFor="linkInput">Folder Link</label>
                            <input
                                name="folderLink"
                                type="url"
                                id="linkInput"
                                value={feedback.folderLink}
                                onChange={handleChange}
                                readOnly={true}
                                placeholder=""
                                className={errors.folderLink ? 'error' : ''}
                            />
                            {feedback.folderLink && (
                                <div>
                                    <a href={feedback.folderLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.folderLink && <div className="error-text">{errors.folderLink}</div>}
                        </div> */}
{/*                         <div className="formInput">
                            <label htmlFor="linkInput">Report Link</label>
                            <input
                                name="reportLink"
                                type="url"
                                id="linkInput"
                                value={feedback.reportLink}
                                onChange={handleChange}
                                readOnly={true}
                                placeholder=""
                                className={errors.reportLink ? 'error' : ''}
                            />
                            {feedback.reportLink && (
                                <div>
                                    <a href={feedback.reportLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.reportLink && <div className="error-text">{errors.reportLink}</div>}
                        </div>

                        <div className="formInput">
                            <label htmlFor="linkInput">Presentation Link</label>
                            <input
                                name="presentationLink"
                                type="url"
                                id="linkInput"
                                value={feedback.presentationLink}
                                onChange={handleChange}
                                readOnly={true}
                                placeholder=""
                                className={errors.presentationLink ? 'error' : ''}
                            />
                            {feedback.presentationLink && (
                                <div>
                                    <a href={feedback.presentationLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.presentationLink && <div className="error-text">{errors.presentationLink}</div>}
                        </div>

                        <div className="formInput">
                            <label htmlFor="linkInput">Presentation Video Link</label>
                            <input
                                name="presentationVideoLink"
                                type="url"
                                id="linkInput"
                                value={feedback.presentationVideoLink}
                                onChange={handleChange}
                                readOnly={true}
                                placeholder=""
                                className={errors.presentationVideoLink ? 'error' : ''}
                            />
                            {feedback.presentationVideoLink && (
                                <div>
                                    <a href={feedback.presentationVideoLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.presentationVideoLink && <div className="error-text">{errors.presentationVideoLink}</div>}
                        </div>
                        
                        <div className="formInput">
                            <label htmlFor="linkInput">Turnitin</label>
                            <input
                                name="turnitin"
                                type="url"
                                id="linkInput"
                                value={feedback.turnitin}
                                onChange={handleChange}
                                readOnly={true}
                                placeholder=""
                                className={errors.turnitin ? 'error' : ''}
                            />
                            {feedback.turnitin && (
                                <div>
                                    <a href={feedback.turnitin} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.turnitin && <div className="error-text">{errors.turnitin}</div>}
                        </div>
 */}

                        <div className="formInput">
                        <h3 style={{ marginTop: "30px", textDecoration: "underline" }}>Submission For Evaluation</h3>
                         <div>
    <strong>Report Type:</strong> {feedback.type}
    <span style={{ marginLeft: "20px" }}>
        <strong>Submission Type:</strong> {" "}
        {feedback.term_type}
       {/* {statusLabelMap[feedback.termThesisStatus] || feedback.termThesisStatus} */}
    </span>
</div>

                        <div>
                        {feedback.reportLink && <a href={feedback.reportLink} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            Report File
                            </a>}
                        {errors.reportLink && <div className="error-text">{errors.reportLink}</div>}
                        </div>

                        <div>
                        {feedback.presentationLink && <a href={feedback.presentationLink} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            Presentation File
                            </a>}
                        {errors.presentationLink && <div className="error-text">{errors.presentationLink}</div>}
                        </div>

                        <div>
                        {feedback.presentationVideoLink && <a href={feedback.presentationVideoLink} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            Presentation Video
                            </a>}
                        {errors.presentationVideoLink && <div className="error-text">{errors.presentationVideoLink}</div>}
                        </div>

                        <div>
                        {feedback.codeDemoLink && <a href={feedback.codeDemoLink} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            Code Demo File
                            </a>}
                        {errors.codeDemoLink && <div className="error-text">{errors.codeDemoLink}</div>}
                        </div>

                        <div>
                        {feedback.turnitin && <a href={feedback.turnitin} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            Turnitin File
                            </a>}

                        {errors.turnitin && <div className="error-text">{errors.turnitin}</div>}
                        </div>

                        <div>
                        {feedback.rebuttalReportLink && <a href={feedback.rebuttalReportLink} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            Rebuttal Report File
                            </a>}

                        {errors.rebuttalReportLink && <div className="error-text">{errors.rebuttalReportLink}</div>}
                        </div>
                    

                    {/* <pre>{JSON.stringify(examinerFeedbacks, null, 2)}</pre> */}

                                            
                        {/*examinerFeedbacks.length > 0 && (
                        <div className="examiner-feedback-section">
                            <h3>Previous Reports and Feedbacks</h3>
                            <div className="feedback-scroll">
                            {examinerFeedbacks
                            .filter((exam) => exam.is_examiner && (exam.report_type !== feedback.type || (exam.report_type === feedback.type && exam.term_type !== feedback.term_type))) 
                            .map((exam, idx) => (
                                <div key={idx} className="examiner-card">
                                {/*<p><strong>{exam.report_type}</strong></p>
                                <p><strong>{exam.report_type}</strong> — {exam.term_type }</p>}
                         <p>
                        <strong>{exam.report_type}</strong> —{" "}
                            {exam.term_type === null || exam.term_type === "EndTerm"
                                         ? "End Term Report"
                              : exam.term_type === "RevisedReport"
                                          ? "Revised Report"
                                : exam.term_type}
                                            </p>


                                <ul>
                                    <li><strong>Report Link:</strong> <a href={exam.report_link} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Report
                            </a></li>
                                    {exam.report_feedback && <li><strong>Feedback on Report:</strong> {exam.report_feedback || "—"}</li>}
                                    {exam.presentation_feedback && <li><strong>Feedback on Presentation:</strong> {exam.presentation_feedback || "—"}</li>}
                                    {exam.overall_feedback && <li><strong>Overall Feedback:</strong> {exam.overall_feedback || "—"}</li>}
                                   {/* <li><strong>Other Feedbacks (shared with admin only):</strong> {exam.other_feedback || "—"}</li> 
                                </ul>
                                </div>
                            ))}
                            </div>
                        </div>
                        )*/}
                        
                           {examinerFeedbacks.length > 0 && (
                        <div className="examiner-feedback-section">
                             <h3 style={{ marginTop: "30px", textDecoration: "underline" }}>Previous Reports and Feedback</h3>
                           
                            <div className="feedback-scroll">
                            {examinerFeedbacks
                           // .filter((exam) => exam.is_examiner && (exam.report_type !== feedback.type || (exam.report_type === feedback.type && exam.share_to_student==true))) 
                            .map((group, idx) => (
                                <div key={idx} className="examiner-card">
                                {/*<p><strong>{exam.report_type}</strong></p>
                                <p><strong>{exam.report_type}</strong> — {exam.term_type }</p> */}
                         <p>
                        <strong>{"Report Type"}</strong> : {group.report_type} <span style={{ marginLeft: "20px" }}></span><strong>{"Submission Type"}</strong> : {group.term_type}{" "}</p>
                            <p> <strong>{"Evaluation Status"}</strong> : {" "}
                            {group.thesis_viva_status === null || group.thesis_viva_status === "WORK_IN_PROGRESS"
                                         ? "End Term Report"
                              : group.thesis_viva_status === "REPORT_REVISION_REQUIRED"
                                          ? "Report revision required"
                              : group.thesis_viva_status === "RESUBMISSION"
                                          ? "Resubmission is required for re-evaluation"
                              : group.thesis_viva_status === "PHASE_COMPLETED"
                                          ? "Report accepted"
                              
                                : group.thesis_viva_status}
                                            </p>
                            <strong>Report Link:</strong> <a href={group.report_link} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Report
                            </a>                

                                <h4>Feedback from Examiners:</h4>

                                     

                                
                                    {group.feedbacks.map((exam, i) => (
                                <li style={{ listStyleType: "none" }} key={i} className="examiner-feedback">
                                 <h4><strong>Examiner {i+1}:</strong> </h4>
                                 <ul >
                                    {exam.report_feedback && (<li><strong>Feedback on Report:</strong> {exam.report_feedback || "—"}</li>)}
                                    {exam.presentation_feedback && (<li><strong>Feedback on Presentation:</strong> {exam.presentation_feedback || "—"}</li>)}
                                    {exam.overall_feedback&& (<li><strong>Overall Feedback:</strong> {exam.overall_feedback || "—"}</li>)}
                                   {/* <li><strong>Other Feedbacks (shared with admin only):</strong> {exam.other_feedback || "—"}</li> */}
                                </ul>
                                </li>
                                    ))}
                                
                                </div>
                            ))}
                            </div>
                        </div>
                        )}
                        
                      </div>
                        {feedback.type == "Monthly" && <div className="Monthly">
                            {/* <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Introduction and Motivation : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                            <li> Clearly states the research problem (max : 2.5 marks)</li>
                                            <li> Demonstrates an understanding of relevant background literature and makes a strong use case of the proposed problem (max : 2.5 marks)</li>
                                            <li> Identifies gaps and limitations in existing research (max : 2.5 marks)</li>
                                            <li> Provides a clear roadmap for the rest of the thesis (max : 2.5 marks)</li>

                                        </ul>

                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeIntroMotivation"
                                    value={feedback.gradeIntroMotivation}
                                    className={errors.gradeIntroMotivation ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option> 
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeIntroMotivation && <div className="error-text">{epresentationFeedbackrrors.gradeIntroMotivation}</div>}
                            </div>
                            <div className="monthlyInput">
                                <label>Comments on Introduction & Motivation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="introMotivation"
                                    value={feedback.introMotivation}
                                    onChange={handleChange}
                                    className={errors.introMotivation ? 'error' : ''} />
                                {errors.introMotivation && <div className="error-text">{errors.introMotivation}</div>}
                            </div>


                            <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Problem Statement : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                            <li> Clearly articulates the research problem (max: 2 marks)</li>
                                            <li> Defines the scope and boundaries of the study (max: 2 marks)</li>
                                            <li> Demonstrates the importance and relevance of the problem within the field (max: 2 marks)</li>
                                            <li> Demonstrates the feasibility of addressing the problem within the given constraints (max: 2 marks)</li>
                                            <li> Aligns with overall objectives and goals of the thesis (max: 2 marks)</li>

                                        </ul>

                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeProblemStmt"
                                    value={feedback.gradeProblemStmt}
                                    className={errors.gradeProblemStmt ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeProblemStmt && <div className="error-text">{errors.gradeProblemStmt}</div>}
                            </div>
                            <div className="monthlyInput">
                                <label>Comments on Problem Statement</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="problemStmt"
                                    value={feedback.problemStmt}
                                    onChange={handleChange}
                                    className={errors.problemStmt ? 'error' : ''} />
                                {errors.problemStmt && <div className="error-text">{errors.problemStmt}</div>}
                            </div>

                            <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Literature Survey </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                            <li> Provides a coherent flow of ideas highlighting the gaps in literature and mentioning the contribution of the thesis in light of the gaps in the literature (max: 2.5 marks)</li>
                                            <li> Incorporates recent and up-to-date sources (max: 2.5 marks)</li>
                                            <li> Provides clear citations and references (max: 2.5 marks)</li>
                                            <li> Highlights the relevance of existing literature to the current study (max: 2.5 marks)</li>

                                        </ul>

                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeLiteratureSurvey"
                                    value={feedback.gradeLiteratureSurvey}
                                    className={errors.gradeLiteratureSurvey ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeLiteratureSurvey && <div className="error-text">{errors.gradeLiteratureSurvey}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Comments on Literature Survey</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="literatureSurvey"
                                    value={feedback.literatureSurvey}
                                    onChange={handleChange}
                                    className={errors.literatureSurvey ? 'error' : ''} />
                                {errors.literatureSurvey && <div className="error-text">{errors.literatureSurvey}</div>}
                            </div>
                            <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Methodology </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                            <li>  Clearly outlines the methodology (max: 2 marks)</li>
                                            <li> Provides rationale for chosen methodology (max: 2 marks)</li>
                                            <li> Demonstrates alignment between research questions and chosen methods (max: 2 marks)</li>
                                            <li>Describes data clearly and concisely (max: 2 marks)</li>
                                            <li> Provides clear steps for data analysis and model building (max: 2 marks)</li>

                                        </ul>

                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeMethodology"
                                    value={feedback.gradeMethodology}
                                    className={errors.gradeMethodology ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeMethodology && <div className="error-text">{errors.gradeMethodology}</div>}
                            </div>


                            <div className="monthlyInput">
                                <label>Comments on Methodology</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="methodology"
                                    value={feedback.methodology}
                                    onChange={handleChange}
                                    className={errors.methodology ? 'error' : ''} />
                                {errors.methodology && <div className="error-text">{errors.methodology}</div>}
                            </div>


                            <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Results </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                            <li>  Presents results clearly and concisely (max: 2 marks)</li>
                                            <li>  Utilizes appropriate tables, figures or graphs to illustrate findings (max: 2 marks)</li>
                                            <li> Provides thoughtful interpretation of results (max: 2 marks)</li>
                                            <li>Relates findings back to research questions or objectives (max: 2 marks)</li>
                                            <li>Ensures consistency between results and methodology (max: 2 marks)</li>

                                        </ul>

                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeResults"
                                    value={feedback.gradeResults}
                                    className={errors.gradeResults ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeResults && <div className="error-text">{errors.gradeResults}</div>}
                            </div>
                            <div className="monthlyInput">
                                <label>Comments on Results</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="results"
                                    value={feedback.results}
                                    onChange={handleChange}
                                    className={errors.results ? 'error' : ''} />
                                {errors.results && <div className="error-text">{errors.results}</div>}
                            </div>

                            <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Conclusion and Future Work
                                    </span>

                                    <span style={{ fontSize: '14px' }}>
                                        <ul>
                                            <li> Summarizes key findings and contributions of the thesis (max: 4 marks)</li>
                                            <li> Acknowledges limitations and constraints of the study (max: 2 marks)</li>
                                            <li> Identifies areas for future research (max: 4 marks)</li>

                                        </ul>

                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeConclusionFuturework"
                                    value={feedback.gradeConclusionFuturework}
                                    className={errors.gradeConclusionFuturework ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S (9-10)</option>
                                    <option value="A">A (8-9)</option>
                                    <option value="B">B (7-8)</option>
                                    <option value="C">C (6-7)</option>
                                    <option value="D">D (5-6)</option>
                                    <option value="E">E (4-5)</option>
                                </select>
                                {errors.gradeConclusionFuturework && <div className="error-text">{errors.gradeConclusionFuturework}</div>}
                            </div>


                            <div className="monthlyInput">
                                <label>Comments on Conclusion & Future Work</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="conclusionFuturework"
                                    value={feedback.conclusionFuturework}
                                    onChange={handleChange}
                                    className={errors.conclusionFuturework ? 'error' : ''} />
                                {errors.conclusionFuturework && <div className="error-text">{errors.conclusionFuturework}</div>}
                            </div> */}


                            {userRole != 'ROLE_REVIEWER' && <div className="examinerGrade">
                                <label>
                                    Marks on Report (Max. 30)  : 
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title="
                                    The points to be considered in the evaluation of report are:
                                    - Formatting of report
                                    - Motivation and Background literature
                                    - Outline of Methods or Approach
                                    - Dataset Understanding and EDA
                                    - Presentation of Objectives
                                    - Results presentation and Discussion
                                    - Conclusion and Future Work"
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="reportMarks"
                                    max={30}    // maximum marks allowed
                                    min={0}     // minimum marks
                                    value={feedback.reportMarks || ''}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    className={errors.reportMarks ? 'error' : ''}
                                    placeholder="Enter marks out of 30"
                                />

                                {errors.reportMarks && (
                                    <div className="error-text">{errors.reportMarks}</div>
                                )}
                                </div>}


                                {userRole != 'ROLE_REVIEWER' && <div className="examinerGrade">
                                <label>
                                    Marks on Presentation (Max. 20)  :
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title="
                                    The points to be considered in the evalaution of presentation are as follows:
                                    -Clarity and coherence of the content
                                    -Clarity of Presentation (Well-paced, Communicated - -ideas, objectives & results well)
                                    -Completion of the presentation within the allotted time frame
                                    -All materials presented are relevant and lead naturally to the conclusion/recommendation"
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="presentationMarks"
                                    max={20}    // maximum marks allowed
                                    min={0}     // minimum marks
                                    value={feedback.presentationMarks || ''}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    className={errors.presentationMarks ? 'error' : ''}
                                    placeholder="Enter marks out of 20"
                                />

                                {errors.presentationMarks && (
                                    <div className="error-text">{errors.presentationMarks}</div>
                                )}
                                </div>}

                                {userRole != 'ROLE_REVIEWER' && <div className="examinerGrade">
                                <label>
                                    Marks on Questions & Answers and  Novelty & Quality of work (Max. 50)  : 
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title="
                                    The points to be considered in the evalaution  of viva and work are as follows:
                                    -Able to address the questions posed by the committee
                                    -Able to use slides to answer the questions posed by the committee
                                    -Able to answer questions to the point and correctly
                                    -Understanding of fundamentals of the subject
                                    -Results presentation and Discussion
                                    -Novelty, Quality, Correctness of Methodology etc in the work"
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="vivaMarks"
                                    max={50}    // maximum marks allowed
                                    min={0}     // minimum marks
                                    value={feedback.vivaMarks || ''}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    className={errors.vivaMarks ? 'error' : ''}
                                    placeholder="Enter marks out of 30"
                                />

                                {errors.vivaMarks && (
                                    <div className="error-text">{errors.vivaMarks}</div>
                                )}
                                </div> }

                            <div className="monthlyInput">
                                <label>Feedback on Presentation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="presentationFeedback"
                                    value={feedback.presentationFeedback}
                                    onChange={handleChange}
                                    className={errors.presentationFeedback ? 'error' : ''} />
                                {errors.presentationFeedback && <div className="error-text">{errors.presentationFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Feedback on Report</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="reportFeedback"
                                    value={feedback.reportFeedback}
                                    onChange={handleChange}
                                    className={errors.reportFeedback ? 'error' : ''} />
                                {errors.reportFeedback && <div className="error-text">{errors.reportFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Other Feedbacks (shared with admin only)</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="otherFeedback"
                                    value={feedback.otherFeedback}
                                    onChange={handleChange}
                                    className={errors.otherFeedback ? 'error' : ''} />
                                {errors.otherFeedback && <div className="error-text">{errors.otherFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Overall Feedbacks</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="overallFeedback"
                                    value={feedback.overallFeedback}
                                    onChange={handleChange}
                                    className={errors.overallFeedback ? 'error' : ''} />
                                {errors.overallFeedback && <div className="error-text">{errors.overallFeedback}</div>}
                            </div>
                        </div>
                        

                        }


                        {(feedback.type == "Phase1" || feedback.type == "Phase2" || feedback.type == "Phase3") && <div className="Monthly">
                            <br />
                            <h3 style={{ marginTop: "30px", textDecoration: "underline" }}>
            Feedback Form
        </h3>
                            {/* <div className="examinerGrade">
                                <label >

                                    <span style={{ fontSize: '17px' }}> Strong Use Case for the Proposed Problem : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        This criterion evaluates how effectively the student has identified and articulated the relevance and significance of the problem, including problem identification, rationale, and contextual understanding.

                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeProposedProblem"
                                    value={feedback.gradeProposedProblem}
                                    className={errors.gradeProposedProblem ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeProposedProblem && <div className="error-text">{errors.gradeProposedProblem}</div>}
                            </div>

                            <br />

                            <div className="examinerGrade">
                                <label >
                                    <span style={{ fontSize: '17px' }}> Strong Use Case for the Proposed Solution : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        This criterion evaluates how effectively the student has proposed a viable solution to the identified problem, considering the viability of the approach, technical feasibility, data requirements, and creativity and uniqueness.

                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeProposedSolution"
                                    value={feedback.gradeProposedSolution}
                                    className={errors.gradeProposedSolution ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeProposedSolution && <div className="error-text">{errors.gradeProposedSolution}</div>}
                            </div>


                            <br />
                            <div className="examinerGrade">
                                <label >
                                    <span style={{ fontSize: '17px' }}> Conceptual Clarity and Understanding of the Problem : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        This criterion evaluates how well the student demonstrates a clear and deep understanding of the problem, including problem definition, contextual understanding, identification of key issues, analytical depth, and articulation and clarity.
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeProblemUnderstanding"
                                    value={feedback.gradeProblemUnderstanding}
                                    className={errors.gradeProblemUnderstanding ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeProblemUnderstanding && <div className="error-text">{errors.gradeProblemUnderstanding}</div>}
                            </div>
                            <br />

                            <div className="examinerGrade">
                                <label >
                                    <span style={{ fontSize: '17px' }}> Academic Rigour in the Solution Procedure  : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        This criterion evaluates the thoroughness, precision, and scholarly approach the student has employed in developing and presenting their solution.
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeAcademicRigour"
                                    value={feedback.gradeAcademicRigour}
                                    className={errors.gradeAcademicRigour ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeAcademicRigour && <div className="error-text">{errors.gradeAcademicRigour}</div>}
                            </div>

                            <br />

                            <div className="examinerGrade">
                                <label >
                                    <span style={{ fontSize: '17px' }}>
                                        Quantum of Work   : </span>

                                    <span style={{ fontSize: '14px' }}>
                                        This criterion assesses the overall amount and depth of work completed during the master's thesis, including research effort, data analysis, model selection, and the results and outputs produced.
                                    </span>
                                </label>
                                <select onChange={handleChange}
                                    name="gradeWorkQuantum"
                                    value={feedback.gradeWorkQuantum}
                                    className={errors.gradeWorkQuantum ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeWorkQuantum && <div className="error-text">{errors.gradeWorkQuantum}</div>}
                            </div>
                            <br /> */}

                            {userRole != 'ROLE_REVIEWER' && <div className="examinerGrade">
                                <label>
                                    Marks on Report (Max. 30)  : 
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title="
                                    The points to be considered in the evaluation of report are:
                                    - Formatting of report
                                    - Motivation and Background literature
                                    - Outline of Methods or Approach
                                    - Dataset Understanding and EDA
                                    - Presentation of Objectives
                                    - Results presentation and Discussion
                                    - Conclusion and Future Work"
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="reportMarks"
                                    max={30}    // maximum marks allowed
                                    min={0}     // minimum marks
                                    value={feedback.reportMarks || ''}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    className={errors.reportMarks ? 'error' : ''}
                                    placeholder="Enter marks out of 30"
                                />

                                {errors.reportMarks && (
                                    <div className="error-text">{errors.reportMarks}</div>
                                )}
                                </div>}


                                {userRole != 'ROLE_REVIEWER' && <div className="examinerGrade">
                                <label>
                                    Marks on Presentation (Max. 20)  :
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title="
                                    The points to be considered in the evalaution of presentation are as follows:
                                    -Clarity and coherence of the content
                                    -Clarity of Presentation (Well-paced, Communicated - -ideas, objectives & results well)
                                    -Completion of the presentation within the allotted time frame
                                    -All materials presented are relevant and lead naturally to the conclusion/recommendation"
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="presentationMarks"
                                    max={20}    // maximum marks allowed
                                    min={0}     // minimum marks
                                    value={feedback.presentationMarks || ''}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    className={errors.presentationMarks ? 'error' : ''}
                                    placeholder="Enter marks out of 20"
                                />

                                {errors.presentationMarks && (
                                    <div className="error-text">{errors.presentationMarks}</div>
                                )}
                                </div>}

                                {userRole != 'ROLE_REVIEWER' && <div className="examinerGrade">
                                <label>
                                    Marks on Questions & Answers and  Novelty & Quality of work (Max. 50)  : 
                                    <span
                                    style={{ marginLeft: 4, cursor: 'pointer' }}
                                    title="
                                    The points to be considered in the evalaution  of viva and work are as follows:
                                    -Able to address the questions posed by the committee
                                    -Able to use slides to answer the questions posed by the committee
                                    -Able to answer questions to the point and correctly
                                    -Understanding of fundamentals of the subject
                                    -Results presentation and Discussion
                                    -Novelty, Quality, Correctness of Methodology etc in the work"
                                    >
                                    ℹ️
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    name="vivaMarks"
                                    max={50}    // maximum marks allowed
                                    min={0}     // minimum marks
                                    value={feedback.vivaMarks || ''}
                                    onChange={handleChange}
                                    required={userRole==="ROLE_EXAMINER"}
                                    className={errors.vivaMarks ? 'error' : ''}
                                    placeholder="Enter marks out of 30"
                                />

                                {errors.vivaMarks && (
                                    <div className="error-text">{errors.vivaMarks}</div>
                                )}
                                </div> }

                            
                            {userRole != 'ROLE_REVIEWER' && <div className="examinerGrade">
                                <label>Overall Grade </label>
                                <select onChange={handleChange}
                                    name="gradeOverall"
                                    value={feedback.gradeOverall}
                                    required={userRole==="ROLE_EXAMINER"}
                                    className={errors.gradeOverall ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="S">S</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                    <option value="D">D</option>
                                    <option value="E">E</option>
                                    <option value="U">U</option>
                                    <option value="I">I</option>
                                </select>
                                {errors.gradeOverall && <div className="error-text">{errors.gradeOverall}</div>}
                            </div>}


                            <div className="monthlyInput">
                                <label>Feedback on Presentation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="presentationFeedback"
                                    value={feedback.presentationFeedback}
                                    onChange={handleChange}
                                    className={errors.presentationFeedback ? 'error' : ''} />
                                {errors.presentationFeedback && <div className="error-text">{errors.presentationFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Feedback on Report</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="reportFeedback"
                                    value={feedback.reportFeedback}
                                    onChange={handleChange}
                                    className={errors.reportFeedback ? 'error' : ''} />
                                {errors.reportFeedback && <div className="error-text">{errors.reportFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Other Feedbacks (shared with admin only)</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="otherFeedback"
                                    value={feedback.otherFeedback}
                                    onChange={handleChange}
                                    className={errors.otherFeedback ? 'error' : ''} />
                                {errors.otherFeedback && <div className="error-text">{errors.otherFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Overall Feedbacks</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="overallFeedback"
                                    value={feedback.overallFeedback}
                                    onChange={handleChange}
                                    className={errors.overallFeedback ? 'error' : ''} />
                                {errors.overallFeedback && <div className="error-text">{errors.overallFeedback}</div>}
                            </div>
                            
                            {/* <div className="formInput">
                                <label>Is the problem mentioned in the problem statement solved?</label>
                                <input type="text"
                                    name="problemSolved"
                                    value={feedback.problemSolved}
                                    onChange={handleChange}
                                    className={errors.problemSolved ? 'error' : ''} />
                                {errors.problemSolved && <div className="error-text">{errors.problemSolved}</div>}
                            </div> */}
                        </div>

                        }
                        {(feedback.type == "ProjectProposal") && <div className="Monthly">
                            <h3 style={{ marginTop: "30px", textDecoration: "underline" }}>
            Feedback Form
        </h3>
                            <div className="monthlyInput">
                                <label>Feedback on Presentation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="presentationFeedback"
                                    value={feedback.presentationFeedback}
                                    onChange={handleChange}
                                    className={errors.presentationFeedback ? 'error' : ''} />
                                {errors.presentationFeedback && <div className="error-text">{errors.presentationFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Feedback on Report</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="reportFeedback"
                                    value={feedback.reportFeedback}
                                    onChange={handleChange}
                                    className={errors.reportFeedback ? 'error' : ''} />
                                {errors.reportFeedback && <div className="error-text">{errors.reportFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Other Feedbacks (shared with admin only)</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="otherFeedback"
                                    value={feedback.otherFeedback}
                                    onChange={handleChange}
                                    className={errors.otherFeedback ? 'error' : ''} />
                                {errors.otherFeedback && <div className="error-text">{errors.otherFeedback}</div>}
                            </div>

                            <div className="monthlyInput">
                                <label>Overall Feedbacks</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="overallFeedback"
                                    value={feedback.overallFeedback}
                                    onChange={handleChange}
                                    className={errors.overallFeedback ? 'error' : ''} />
                                {errors.overallFeedback && <div className="error-text">{errors.overallFeedback}</div>}
                            </div>


                        </div>

                        }
                        <div className="buttons">
                            <button type="submit">{'Save'}</button>
                            <button onClick={goBack}>Back</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};


